import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
import { ResetPasswordService } from "./reset-password.service";

@Component({
    selector: "app-reset-password",
    templateUrl: "./reset-password.component.html",
    styleUrls: ["./reset-password.component.css"],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  passwordForm!: FormGroup;
  userId: number | undefined;
  token: string = sessionStorage.getItem('token') || ''; // Provide a default value for the token

  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private resetPasswordService: ResetPasswordService
  ) {} // Inject ResetPasswordService

  ngOnInit(): void {
    this.passwordForm = this.fb.group(
      {
        currentPassword: ["", Validators.required],
        newPassword: ["", [Validators.required, Validators.minLength(8)]],
        confirmNewPassword: ["", Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get("newPassword")?.value;
    const confirmNewPassword = control.get("confirmNewPassword")?.value;
    if (newPassword !== confirmNewPassword) {
      return { passwordMismatch: true };
    }
    return null;
  }

  toggleShowPassword(field: string) {
    switch (field) {
      case 'current':
        this.showCurrentPassword = !this.showCurrentPassword;
        break;
      case 'new':
        this.showNewPassword = !this.showNewPassword;
        break;
      case 'confirm':
        this.showConfirmPassword = !this.showConfirmPassword;
        break;
    }
  }

  onSubmit(): void {
    if (this.passwordForm.valid) {
      const userId: any = localStorage.getItem('userId');
      const newPassword = this.passwordForm.get("newPassword")?.value;

      this.resetPasswordService.resetPassword(userId, newPassword, this.token).subscribe(
        (response) => {
          this.passwordForm.reset();
        },
        (error) => {
        }
      );
    }
  }
}
